export const PAYMENT_METHOD_CREDIT_CARD_CONTAINER_WIDTH = 396;

export const PAYMENT_METHOD_DIRECT_ACH_CONTAINER_WIDTH = '35rem';

export const PAYMENT_SECTION_WIDTH = '60rem';
